import {
  Divider,
  IconButton,
  InputAdornment,
  ListItemButton,
  ListItemText,
  MenuItem,
  Stack,
  TextFieldProps,
  Tooltip,
} from "@mui/material";
import FunctionIcon from "common/icons/FunctionIcon";
import { editExpressionAtProp } from "developer/edit/store/expressionEditorSlice";
import { EditorVariant } from "developer/edit/types";
import { isEmpty } from "lodash";
import React, { useCallback } from "react";
import { useAppDispatch } from "store/hooks";
import EditorVisualTextField from "../../EditorVisualTextField";

type ExpressionFieldProps = TextFieldProps & {
  type: "text" | "select";
  targetProp: string;
  value: string;
};

const ExpressionField: React.FC<ExpressionFieldProps> = (props) => {
  const { type, targetProp, value, ...rest } = props;
  const dispatch = useAppDispatch();

  const isSelectField =
    type === "select" && (["true", "false"].includes(value) || isEmpty(value));

  const handleEditExpression = useCallback(() => {
    dispatch(
      editExpressionAtProp({
        content: value,
        targetProp,
        targetEditor: EditorVariant.Layout,
      })
    );
  }, [dispatch, value, targetProp]);

  if (isSelectField) {
    return (
      <EditorVisualTextField
        select
        multiline
        value={value}
        {...rest}
        SelectProps={{
          MenuProps: { sx: { zIndex: (theme) => theme.zIndex.drawer - 1 } },
        }}
      >
        <MenuItem value="true">True</MenuItem>
        <MenuItem value="false">False</MenuItem>
        <Divider variant="fullWidth" />
        <MenuItem sx={{ p: 0 }}>
          <ListItemButton
            onClick={(event) => {
              event.stopPropagation();
              handleEditExpression();
            }}
          >
            <Stack direction="row" spacing={2}>
              <FunctionIcon />
              <ListItemText primary="Edit Expression" />
            </Stack>
          </ListItemButton>
        </MenuItem>
      </EditorVisualTextField>
    );
  }

  return (
    <EditorVisualTextField
      multiline
      minRows={1}
      maxRows={2}
      value={value}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title="Edit Expression">
              <IconButton onClick={handleEditExpression}>
                <FunctionIcon />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
      {...rest}
    />
  );
};

export default ExpressionField;
